import React, { useContext, useEffect, useRef } from 'react'
import { Box, Button } from '@mui/material'

import LanguageContext from '../../../contexts/LanguageContext'
import { useTexte } from '../../../contexts/FormeAdresseContext'
import { IconeCadenas } from '../CertificationNonDisponible'

/* ⛔ « MON BILAN SOFT SKILLS », DERNIERE ETAPE DE « VOTRE PROGRAMME »
   (07/10/2026 ; etape 2 : branchee dans pages/Dashboard.js).

   Visible des le depart, apres le dernier module, pour un apprenant dont le
   plan mesure des competences du referentiel (Bilan/donneesBilan.js) :
     - « verrouillee » : cadenas a cote du titre (celui de l'onglet « Ma
       certification » verrouille) et « Disponible à la fin de ton parcours » ;
     - « incomplete » : parcours termine mais moins de 3 competences mesurees :
       meme cadenas, message neutre ;
     - « disponible » : « Ton bilan est prêt » et le bouton « Voir mon bilan »
       (meme bouton que « Commencer »), qui ouvre la fenetre du bilan. Au
       deverrouillage, la liste defile jusqu'a la ligne (apres le defilement
       vers le module en cours, qui la precede).
   Tu ou vous : `useTexte` (forme d'adresse publiee).

   MEME STRUCTURE ET MEMES STYLES que les autres lignes (SteppedCard,
   pages/Dashboard.js) : hauteur 60 / 60 / 120 / 75 px, point de 13 px,
   titre 15 / 16 px, etat 13 / 14 px, bouton 32 px. C'est la derniere ligne :
   pas de trait apres son point ; la ligne du dernier module garde le sien. */

const LigneBilan = ({ etat = 'verrouillee', onVoir }) => {
  const { languageValues } = useContext(LanguageContext)
  const t = useTexte()
  const L = (cle) => t(languageValues?.bilanSoftSkills?.[cle])
  const disponible = etat === 'disponible'
  const ref = useRef(null)

  /* au deverrouillage, la liste defile jusqu'a la ligne, qui est sa derniere
     etape. On fait defiler LA LISTE, et elle seule : `scrollIntoView` avec
     `container` n'existe pas dans tous les Safari, et ferait alors defiler
     toute la page sur un telephone. */
  useEffect(() => {
    const liste = ref.current?.parentElement
    if (disponible && liste && liste.scrollHeight > liste.clientHeight) liste.scrollTop = liste.scrollHeight
  }, [disponible])

  const message = disponible ? L('ligneDisponible') : etat === 'incomplete' ? L('ligneIncomplete') : L('ligneVerrouillee')

  return (
    <Box ref={ref} data-ligne-bilan={etat} sx={{
      height:["60px", "60px", "120px", "75px"],
      display:"flex",
      flexDirection:["row", "row", "column", "row"],
      flex:1,
      justifyContent:"space-between",
      gap:"15px",
      overflow:"hidden",
    }}>
      <Box sx={{
        display:"flex",
        flexDirection:["row", "row", "column", "row"],
        gap:"15px",
        overflow:"hidden",
      }}>
        <Box sx={{
          display:["block", "block", "flex", "block"],
        }}>
          <Box sx={{
            width:"13px",
            height:"13px",
            border:"1px solid black",
            borderRadius:"50%",
          }} />
        </Box>
        <Box sx={{
          display:"flex",
          flexDirection:"column",
          gap:"7px",
          overflow:"hidden",
        }}>
          <Box sx={{
            color:"text.black",
            fontSize:["15px", "15px", "15px", "16px"],
            whiteSpace:"noWrap",
            overflow:"hidden",
            display:"flex",
            alignItems:"center",
            gap:"7px",
          }}>
            <Box component="span" sx={{ overflow:"hidden", textOverflow:"ellipsis", minWidth:0 }}>
              {L('ligneTitre')}
            </Box>
            {!disponible &&
              <Box component="span" data-bilan-verrouille sx={{ color:"#8A8480", display:"inline-flex", flexShrink:0 }}>
                <IconeCadenas taille={12} />
              </Box>
            }
          </Box>
          <Box sx={{
            color:"text.black",
            fontSize:["13px", "13px", "13px", "14px"],
            whiteSpace:"noWrap",
            overflow:"hidden",
            textOverflow:"ellipsis",
          }}>
            {message}
          </Box>
        </Box>
      </Box>
      <Box>
        {disponible &&
          <Button
            data-voir-bilan
            onClick={onVoir}
            size="small"
            type="button"
            variant="contained"
            sx={{
              fontSize:"13px !important",
              height:"32px !important",
              minHeight:"32px !important",
              whiteSpace:"noWrap",
            }}
          >
            {L('voir')}
          </Button>
        }
      </Box>
    </Box>
  )
}

export default LigneBilan
